export const CURRENCIES = ['USD', 'EUR', 'GBP', 'JPY', 'CAD', 'AUD', 'CHF'] as const

export const UNITS = [
  { value: 'units', label: 'Units' },
  { value: 'user', label: 'User' },
  { value: 'ride', label: 'Ride' },
  { value: 'seat', label: 'Seat' },
  { value: 'api_call', label: 'API call' },
  { value: 'other', label: 'Other' }
] as const

export const BILLING_FREQUENCIES = [
  { value: 'once', label: 'Once', description: 'Usage resets / measured every month' },
  { value: 'daily', label: 'Daily', description: 'Usage resets / measured every month' },
  { value: 'weekly', label: 'Weekly', description: 'Usage resets / measured every month' },
  { value: 'quarterly', label: 'Quarterly', description: 'Aggregated usage over each 3-month window' },
  { value: 'annually', label: 'Annually', description: 'Usage tracked per year' },
  { value: 'custom', label: 'Custom period', description: 'Set your own period (days / weeks)' }
] as const

